<template>
  <v-container v-if="this.staedte">
    <v-layout
      v-if="this.staedte.length > 0"
      row
      wrap
    >
      <v-flex
        v-for="stadt in this.staedte"
        :key="stadt.id"
        xs12    
      >
        <v-btn
          v-if="stadt.hidden === 0 || stadt.hidden == null"
          large
          class="my-2 mx-0 text-xs-center"
          color="accent"
          @click="changeHeimatStadt(stadt.name)"
          :to="{ name: 'Landing', params: {landing: LandingSlug, stadt: stadt.name.toLowerCase() }}"
        >{{ LandingName }} in {{ stadt.name }}</v-btn>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['staedte', 'landing'],
  data () {
    return {
      betriebcheckloading: true
    }
  },
  computed: {
    LandingSlug: function () {
      return this.landing.slug
    },
    LandingName: function () {
      return this.landing.name
    }
    // EigeneAnzeige: function () {
    //   if (this.$store.getters.authUser) {
    //     if (this.$store.getters.authUser.id === this.anzeige.user.id) return true
    //   }
    // },
    // LetztesBild: function () {
    //   return this.anzeige.media[this.anzeige.media.length - 1].fullurl
    // }
  },
  mounted: function () {},
  methods: {
    ...mapActions({
      changeHeimatStadt: 'setStadt' // map `this.add()` to `this.$store.dispatch('increment')`
    })

    // ...
  }
}
</script>

<style>
</style>